<template>
<div class="chapter">
<div class="inner_page">
<div class="ipadfp"><img alt="The Peculiar Incident on Shady Street, by Lindsay Currie." class="imagefp" src="images/9781481477062.jpg"/></div>
<div class="ipadfp"><a id="page_i"></a><a id="page_ii"></a><a id="page_iii"><img alt="images" class="imagefp" src="images/title.jpg"/></a></div><a id="page_iii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?3fb66bd9